import { computed, signal } from "@preact/signals-react"

export const nextCheck = signal(null)
export const userData = signal({})
export const favFilterSelected = signal(null)
export const loadedFavFilters = signal(false)

export const customerID = computed(() => userData.value?.customerID)
export const userID = computed(() => userData.value?.id_user)
export const hasAiInsights = computed(() => !!userData.value?.hasAiInsights)
export const clickAndCollect = computed(() => !!userData.value?.clickAndCollect)